module.exports = __webpack_public_path__ + "img/brand_LHG.9f9c4b7d.png";